import { call, put, takeEvery } from "redux-saga/effects";
import requestWithSubTenantIfNeeded from "../requestWithSubTenantIfNeeded";
import * as actions from "./serviceGetActions";

function* serviceGet(action) {
  try {
    let { data } = yield call(
      requestWithSubTenantIfNeeded,
      "get",
      `services/${action.id}`
    );

    const { service, relationships } = data;

    const references = relationships.references
      .filter((reference) => reference.sharedObjectId === action.id)
      .map((reference) => reference.referenceCollection);

    yield put(actions.requestSuccess({ ...service, references }, action.id));
  } catch (error) {
    yield put(actions.requestFailure(error, action.id));
  }
}

function* saga() {
  yield takeEvery(actions.SERVICE_GET_REQUEST, serviceGet);
}

export default saga;
